<script setup lang="ts">
import ChipButton from '@/shared/components/ChipButton.vue';

const props = defineProps({
	checks: { type: Array, required: true },
});

const emit = defineEmits(['onChange']);

const toggle = (check: any) => {
	check.selected = !check.selected;
	emit('onChange', check);
};
</script>

<template>
	<div class="flex flex-wrap gap-2">
		<ChipButton v-for="check in checks" :key="check.name" :label="check.name" :selected="check.selected" @click="toggle(check)" />
	</div>
</template>
